import { Box, Typography } from "@mui/material";
import PairLogos from "../PairLogos";

// columns: name, status, earned, staked, total staked (the last three from md up)
const EARN_COLUMNS = { xs: "minmax(0, 1fr) auto", md: "minmax(0, 1fr) 110px 150px 150px 170px" };

const headerSx = { color: "text.secondary" };
const desktopOnly = { display: { xs: "none", md: "block" }, textAlign: "right" };

/**
 * Table of farms or pools
 * rows: [{ key, tokens: [tokenA, tokenB], name, status, earned, staked, total, onOpen }]
 */
const EarnTable = ({ rows, nameLabel, emptyText }) => (
  <Box>
    <Box aria-hidden sx={{ display: "grid", gridTemplateColumns: EARN_COLUMNS, gap: 2, px: 2.5, pb: 1.5 }}>
      <Typography variant="body2" sx={headerSx}>
        {nameLabel}
      </Typography>
      <Typography variant="body2" sx={{ ...headerSx, textAlign: { xs: "right", md: "left" } }}>
        Status
      </Typography>
      <Typography variant="body2" sx={{ ...headerSx, ...desktopOnly }}>
        Earned
      </Typography>
      <Typography variant="body2" sx={{ ...headerSx, ...desktopOnly }}>
        Your stake
      </Typography>
      <Typography variant="body2" sx={{ ...headerSx, ...desktopOnly }}>
        Total staked
      </Typography>
    </Box>
    {rows.length === 0 ? (
      <Typography sx={{ px: 2.5, py: 3, borderTop: 1, borderColor: "divider", color: "text.secondary" }}>
        {emptyText}
      </Typography>
    ) : (
      <Box component="ul" sx={{ m: 0, p: 0 }}>
        {rows.map((row) => (
          <Box component="li" key={row.key} sx={{ listStyle: "none", borderTop: 1, borderColor: "divider" }}>
            <Box
              component="button"
              type="button"
              onClick={row.onOpen}
              aria-label={`Open ${row.name}`}
              sx={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: EARN_COLUMNS,
                alignItems: "center",
                gap: 2,
                px: 2.5,
                py: 2,
                border: 0,
                background: "none",
                color: "inherit",
                font: "inherit",
                textAlign: "left",
                cursor: "pointer",
                "&:hover": { backgroundColor: "background.light" },
                "&:focus-visible": { outline: "2px solid", outlineColor: "primary.main", outlineOffset: "-2px" },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                <PairLogos tokens={row.tokens} />
                <Typography noWrap sx={{ fontWeight: 600, fontSize: "1rem" }}>
                  {row.name}
                </Typography>
              </Box>
              <Box sx={{ justifySelf: { xs: "end", md: "start" } }}>{row.status}</Box>
              <Typography sx={desktopOnly}>{row.earned}</Typography>
              <Typography sx={desktopOnly}>{row.staked}</Typography>
              <Typography sx={desktopOnly}>{row.total}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    )}
  </Box>
);

export default EarnTable;
